function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Organization",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Contractor-detail-view",
  transform: "translate(-774.000000, -497.000000)",
  fill: "#E3E5EF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(698.000000, 497.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.1989322,0.506485384 L81.4217989,4.27114482 L77.4457013,4.87678867 C76.7326708,4.9848378 76.4469143,5.90325548 76.9639975,6.42928417 L79.840613,9.35798448 L79.1602403,13.4951291 C79.0377733,14.2429429 79.7916261,14.8030923 80.4230119,14.4533543 L83.98,12.4999397 L87.5369881,14.4533543 C88.1683739,14.8002489 88.9222267,14.2429429 88.7997597,13.4951291 L88.119387,9.35798448 L90.9960025,6.42928417 C91.5130857,5.90325548 91.2273292,4.9848378 90.5142987,4.87678867 L86.5382011,4.27114482 L84.7610678,0.506485384 C84.4426534,-0.16455663 83.5200681,-0.173086825 83.1989322,0.506485384 Z",
  id: "Star_1",
  transform: "translate(83.980000, 7.280000) scale(-1, 1) translate(-83.980000, -7.280000) "
})))));

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c435bd6f.svg";
export { ForwardRef as ReactComponent };